/**
 * Retrieves a nested value from an object based on the provided path.
 *
 * @param {Object} obj - The object to retrieve the value from.
 * @param {string} path - The path to the nested value, separated by dots.
 * @returns {*} The nested value found at the specified path in the object.
 */
const deepValue = function (obj, path) {
    for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
        obj = obj[path[i]];
    }
    return obj;
};

/**
 * Sets a deeply nested value in an object based on the provided path.
 *
 * @param {Object} obj - The object to update.
 * @param {string} path - The path to the nested value, separated by dots.
 * @param {any} value - The new value to set at the specified path.
 */
const setDeepValue = function (obj, path, value) {
    for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
        if (i === len - 1) {
            obj[path[i]] = value;
        }
        obj = obj[path[i]];
    }
};

/**
 * Recursively searches an object to find all key paths that match a given key.
 *
 * @param {Object} obj - The object to search within.
 * @param {string} key - The key to match.
 * @param {string} [currentPath=''] - The current path being traversed (default is an empty string).
 * @param {Array} [result=[]] - An array to store the matched key paths (default is an empty array).
 * @returns {Array} An array of key paths that match the given key.
 */
function getKeyPaths(obj, key, currentPath = '', result = []) {
    if (typeof obj !== 'object' || obj === null) {
        return result;
    }

    for (const property in obj) {
        if (obj.hasOwnProperty(property)) {
            const newPath = currentPath === '' ? property : `${currentPath}.${property}`;

            if (Array.isArray(obj[property])) {
                obj[property].forEach((item, index) => {
                    getKeyPaths(item, key, `${newPath}[${index}]`, result);
                });
            } else {
                getKeyPaths(obj[property], key, newPath, result);
            }

            if (property === key) {
                result.push(newPath);
            }
        }
    }

    return result;
}

/**
 * Updates the provided newTree based on the file and filter.
 *
 * @param {Object} newTree - The tree to be updated.
 * @param {Object} file - The file object to extract value from.
 * @param {string} filter - The filter to specify the path in the file object.
 */
const makeNewTree = (newTree, file, filter) => {
    const value = deepValue(file, filter);
    const paths = filter.split('.');
    paths.reduce(function (newTree, path) {
        return (newTree[path] = path === paths.at(-1) ? value : {});
    }, newTree);
};

export default function intlHooks() {
    return { makeNewTree, setDeepValue, deepValue, getKeyPaths };
}
